export const parseJwtToken = (token: string) => {
    return JSON.parse(window.atob(token
        .split('.')[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/')));
};

const navigationEndpoints = [
    'agentassistlogin',
    'callhistory',
    'contacts',
    'dialogues',
    'login',
    'main',
    'overview',
    'queue',
    'redirect',
    'requestclose',
    'settings'
];

export function baseUrl() {
    const protocolPrefixIndex = window.location.href.indexOf('//');
    const protocolPrefix = protocolPrefixIndex >= 0
        ? window.location.origin.substring(0, protocolPrefixIndex + 2)
        : '';
    const urlPath = /([^#|?]*)(?:[#|?].*)?/g.exec(window.location.href.substring(protocolPrefixIndex + 2))[1];
    let pathHubs = urlPath.split('/').filter(p => p.length);

    const lastHub = pathHubs[pathHubs.length - 1].toLocaleLowerCase();
    const isNavigationEndpoint = navigationEndpoints.some(endpoint => endpoint === lastHub);

    if (isNavigationEndpoint) {
        pathHubs = pathHubs.filter((_, index) => index < pathHubs.length - 1);
    }

    let url = pathHubs.join('/');
    if (url.endsWith('index.html')) {
        url = url.substring(0, url.lastIndexOf('/'));
    }

    return protocolPrefix + url + '/';
}
